import { NO_MARK_THRESHOLD } from '@modules/HappinessModule/constants/reportConstants';
import { ResponsesActivityDataItem } from '../interfaces/ResponsesActivityDataItem';

export const getResponseActivityTableData = (data: ResponsesActivityDataItem[]): ResponsesActivityDataItem[] =>
  data
    .map((d) => ({ ...d, mark: d.mark === null ? NO_MARK_THRESHOLD : d.mark }))
    .sort((d1, d2) => (d1.date > d2.date ? -1 : 1));
